/**
 * @generated SignedSource<<cf70ae08cf6ba7cde7ce20b43f273c35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildPrimaryPhotoNew_guild$data = {
  readonly name: string;
  readonly primaryPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly rowId: string;
  readonly " $fragmentType": "GuildPrimaryPhotoNew_guild";
};
export type GuildPrimaryPhotoNew_guild$key = {
  readonly " $data"?: GuildPrimaryPhotoNew_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildPrimaryPhotoNew_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "primaryPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "dpr",
                  "variableName": "dpr"
                },
                {
                  "kind": "Literal",
                  "name": "fit",
                  "value": "cover"
                },
                {
                  "kind": "Variable",
                  "name": "h",
                  "variableName": "imageSize"
                },
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "imageSize"
                }
              ],
              "kind": "ObjectValue",
              "name": "transform"
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "06e912a6ddd54ba74fe806f43f0428d1";

export default node;
